import { StringSchema } from 'yup'
import { Message } from 'yup/lib/types'

const phoneRegExp = /^1\d\d(\d\d)?$|^0800 ?\d{3} ?\d{4}$|^(\(0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d\) ?|0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d[ .-]?)?(9|9[ .-])?[2-9]\d{3}[ .-]?\d{4}$/gm


export function phone(
  this: StringSchema,
  message?: Message<{ regex: RegExp }>,
  optional?: boolean
) {
  return this.test('phone', function (value?: string) {
    return (
      (optional && value?.replace?.(/[^\d]/g, '')?.length === 0) ||
      (value && phoneRegExp.test(value)) ||
      this.createError({
        type: 'phone',
        path: this.path,
        message: message || 'invalid_phone_number'
      })
    )
  })
}
